<template>
  <span :class="['tag', type]"><slot /></span>
</template>

<script setup lang="ts">
  defineProps<{
    type: 'regular' | 'bold' | 'medium'
  }>();
</script>

<style scoped lang="scss">
  .tag {
    font-size: remc(16px);
    line-height: remc(16px);
    color: $brand-secondary-100-light-navy;

    &.regular {
      font-weight: 400;
    }

    &.medium {
      font-weight: 500;
    }

    &.bold {
      font-weight: 600;
    }
  }
</style>
